export default __webpack_public_path__ + "static/media/NzkzZDYxNTkt-OWQwMzQwNDUt-w3000._CB663569411_.c4d72122.jpg";